import React from 'react';
import { node } from 'prop-types';

import AuthProvider from '@context/auth';
import AlertProvider from '@context/alert';
import LocationProvider from '@context/location';
import CoachmarkProvider from '@context/coachmark';
import LayoutProvider from '@context/layout';
import { PriceSocketProvider } from '@context/websocket';

import MarginTradingProvider from '@context/marginTrading';
import DayTradingProvider from '@context/daytrading';
import MfProvider from '@context/mutualFund';
import BankProvider from '@context/bank';
import StockProvider from '@context/stock';
import { StockBuySellProvider } from '@context/stock/buysell';
import KycDukcapilProvider from '@context/kyc/KycDukcapil';
import KycEddProvider from '@context/kyc/KycEdd';
import WatchlistProvider from '@context/watchlist';

import TrackerProvider from './tracker';
import PriceSocketProvider2 from './websocket/PriceSocket';
import StockTickerTabProvider from './stockTickerTab';

const GlobalProvider = ({ children }) => {
  return (
    <TrackerProvider>
      <AuthProvider>
        <AlertProvider>
          <LocationProvider>
            <CoachmarkProvider>
              <MarginTradingProvider>
                <StockProvider>
                  <MfProvider>
                    <BankProvider>
                      <DayTradingProvider>
                        <LayoutProvider>
                          <PriceSocketProvider>
                            <StockBuySellProvider>
                              <WatchlistProvider>
                                <KycDukcapilProvider>
                                  <KycEddProvider>
                                    <StockTickerTabProvider>
                                      <PriceSocketProvider2>{children}</PriceSocketProvider2>
                                    </StockTickerTabProvider>
                                  </KycEddProvider>
                                </KycDukcapilProvider>
                              </WatchlistProvider>
                            </StockBuySellProvider>
                          </PriceSocketProvider>
                        </LayoutProvider>
                      </DayTradingProvider>
                    </BankProvider>
                  </MfProvider>
                </StockProvider>
              </MarginTradingProvider>
            </CoachmarkProvider>
          </LocationProvider>
        </AlertProvider>
      </AuthProvider>
    </TrackerProvider>
  );
};

GlobalProvider.propTypes = {
  children: node.isRequired,
};

export default GlobalProvider;
